import {
    SET_CONTRACT_LIST,
    SET_CONTRACT_SUCCESS_MESSAGE,
    SET_CONTRACT_ERROR_MESSAGE,
    REQUEST_CONTRACTS
} from "../actions/types";

const INITIAL_STATE = {
    contractList: [],
    contractSucessMsg: null,
    contractErrorMsg: null,
    ops: "",
    isFetching: false
};


export default function contractReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REQUEST_CONTRACTS:
            return { ...state, isFetching: action.payload };
        case SET_CONTRACT_LIST:
            return {
                ...state,
                contractList: action.payload,
                isFetching: false
            };
        case SET_CONTRACT_SUCCESS_MESSAGE:
            return {
                ...state,
                contractSucessMsg: action.payload.msg,
                ops: action.payload.ops,
                isFetching: false
            };
        case SET_CONTRACT_ERROR_MESSAGE:
            return {
                ...state,
                contractErrorMsg: action.payload.msg,
                ops: action.payload.ops,
                isFetching: false
            };
        default:
            return state;
    }
}